import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-5 flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex items-center gap-3 text-right" }
const _hoisted_4 = { class: "flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-800" }
const _hoisted_5 = { class: "mb-5 rounded-2xl border border-slate-200 bg-slate-50/70 p-3 sm:p-4" }
const _hoisted_6 = { class: "mb-4 grid grid-cols-1 gap-2 sm:grid-cols-3" }
const _hoisted_7 = { class: "mb-3 flex items-center justify-between text-xs text-slate-500" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_IpgTransactionSkelton = _resolveComponent("IpgTransactionSkelton")!
  const _component_UsersTableComponent = _resolveComponent("UsersTableComponent")!
  const _component_CustomPaginationComponent = _resolveComponent("CustomPaginationComponent")!
  const _component_UserProfileInfo = _resolveComponent("UserProfileInfo")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "users-list pa-2 my-3 sm:pa-4 sm:my-6"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        flat: "",
        class: "user-list-card pa-3 rounded-2xl sm:pa-6"
      }, {
        default: _withCtx(() => [
          (_ctx.statusComponent === 'users')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, [
                      _createVNode(_component_v_icon, { size: "23" }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-account-search", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                      _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "لیست کاربران سیستم"),
                      _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "کاربران را جستجو و بر اساس وضعیت فیلتر کنید")
                    ], -1))
                  ]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "tonal",
                    rounded: "lg",
                    class: "text-caption font-weight-medium",
                    "prepend-icon": "mdi-arrow-right",
                    onClick: _ctx.back
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" بازگشت به کاربران ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_row, {
                    dense: "",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        lg: "3",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.search.phone,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.phone) = $event)),
                            label: "شماره تلفن",
                            variant: "outlined",
                            density: "comfortable",
                            clearable: "",
                            "prepend-inner-icon": "mdi-phone",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        lg: "3",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.search.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.name) = $event)),
                            label: "نام",
                            variant: "outlined",
                            density: "comfortable",
                            clearable: "",
                            "prepend-inner-icon": "mdi-account",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        lg: "3",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.search.email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.email) = $event)),
                            label: "ایمیل",
                            variant: "outlined",
                            density: "comfortable",
                            clearable: "",
                            "prepend-inner-icon": "mdi-email",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        lg: "3",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            block: "",
                            rounded: "lg",
                            class: "h-12 text-caption font-weight-medium",
                            onClick: _ctx.performSearch
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { start: "" }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("mdi-magnify", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[12] || (_cache[12] = _createTextVNode(" جستجوی کاربران ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, index) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      key: index,
                      block: "",
                      rounded: "lg",
                      color: button.value === _ctx.activeFilterButton ? 'primary' : 'default',
                      variant: button.value === _ctx.activeFilterButton ? 'flat' : 'outlined',
                      class: "text-caption font-weight-medium",
                      "prepend-icon": button.icon,
                      onClick: ($event: any) => (_ctx.setFilterOfUsersList(button.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(button.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["color", "variant", "prepend-icon", "onClick"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "نتایج کاربران بر اساس فیلتر انتخاب‌شده", -1)),
                  (_ctx.getGlobalPagination.total)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(Number(_ctx.getGlobalPagination.total).toLocaleString('fa-IR')) + " کاربر", 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.getLoadingPanel)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      class: "mt-6"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
                          return _createVNode(_component_v_col, {
                            cols: "12",
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_IpgTransactionSkelton)
                            ]),
                            _: 1
                          })
                        }), 64))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_UsersTableComponent, {
                              users: _ctx.getAllUsers,
                              onAccessAccount: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleAccessAccount($event))),
                              onUserCashout: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleUserCashout($event))),
                              onPanelAccess: _cache[5] || (_cache[5] = ($event: any) => (_ctx.togglePanelAccess($event))),
                              onUserOption: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleUserOption($event)))
                            }, null, 8, ["users"]),
                            (Number(_ctx.getGlobalPagination.total) > Number(_ctx.getGlobalPagination.limit))
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 0,
                                  justify: "center",
                                  class: "mt-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      sm: "8",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CustomPaginationComponent, {
                                          "total-items": _ctx.getGlobalPagination.total,
                                          "items-per-page": 50,
                                          onPageChange: _ctx.handelPagination
                                        }, null, 8, ["total-items", "onPageChange"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ]))
            : _createCommentVNode("", true),
          (_ctx.statusComponent === 'profile')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_UserProfileInfo, {
                  userId: _ctx.user,
                  onBack: _cache[7] || (_cache[7] = ($event: any) => (_ctx.statusComponent = 'users'))
                }, null, 8, ["userId"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}